import circlesActionTypes from './action-types';

export const fetchPendingClosedCircles = payload => ({
  type: circlesActionTypes.FETCH_PENDING_CLOSED_CIRCLES,
  payload,
});

export const fetchPendingClosedCirclesSuccess = payload => ({
  type: circlesActionTypes.FETCH_PENDING_CLOSED_CIRCLES_SUCCESS,
  payload,
});

export const fetchPendingClosedCirclesFail = payload => ({
  type: circlesActionTypes.FETCH_PENDING_CLOSED_CIRCLES_FAIL,
  payload,
});

export const fetchChangeCircleStatusSubmission = payload => ({
  type: circlesActionTypes.FETCH_CHANGE_CIRCLE_STATUS_SUBMISSION,
  payload,
});

export const fetchChangeCircleStatusSubmissionSuccess = payload => ({
  type: circlesActionTypes.FETCH_CHANGE_CIRCLE_STATUS_SUBMISSION_SUCCESS,
  payload,
});

export const fetchChangeCircleStatusSubmissionFail = payload => ({
  type: circlesActionTypes.FETCH_CHANGE_CIRCLE_STATUS_SUBMISSION_FAIL,
  payload,
});
